const ROUTE_PATHS = {
  HOME: "/",
  OFFERS: "/offer",
  TRANSACTION_HISTORY: "/transaction-history",
  AVAILABLE_OFFERS: "available-offers",
  REEDEMED_OFFERS: "reedemed-offers",
  LOYALTY_INFO: "/loyalty-info",
  REFER_FRIEND: "/refer-friend",
  REFER_FRIEND_PWA: "/refer-friend/pwa",
  FRIEND_ENROL: "/refer-friend/enrol",
  REGISTER: `register/:businessHashId`,
  ERROR: "/fail",
  HTML : `/html/:moduleName`,
  QR_REDIRECT: `/customer-verify/:businessHashId`,
  SIGN_UP: `sign-up/:businessHashId`,
  SIGN_UP_SHORTENED: `verify`,
  TERMS_AND_CONDITIONS:'/terms-and-conditions',
  DIRECT_REFER: '/refer-friend/direct/:businessHashId',
  CUSTOMER_LOGIN: '/customer-login/:businessHashId',
  TICKET_DESK: '/tickets',
  SCHEME: '/scheme',
  SCHEME_JOIN: '/scheme/join',
  SCHEME_DETAIL: '/scheme/:schemeId'
};

export default ROUTE_PATHS;
